var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeco3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.27484 25.6191L35.0755 25.6191L35.0755 61.1191C15.8655 61.1191 0.274841 45.2151 0.27484 25.6191Z",
    fill: "#CB3A31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.0365 -10V25.5798H69.7592C69.7592 5.93974 54.2034 -10 35.0365 -10Z",
    fill: "#CB3A31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.7592 25.5801V61.1599C50.5923 61.1599 35.0365 45.2201 35.0365 25.5801H69.7592Z",
    fill: "#EEB4B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.313904 -10V25.5798C19.4808 25.5798 35.0365 9.64004 35.0365 -10H0.313904Z",
    fill: "#EEB4B0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco3);
export default __webpack_public_path__ + "static/media/deco3.95f8e5db4c551794e37298dba7e36d6a.svg";
export { ForwardRef as ReactComponent };